module.exports = __webpack_public_path__ + "02_bob_grey.42b675da.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/02_bob_grey.png
// module id = nc7L
// module chunks = 0